import { FC, useState, useRef, useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { DropdownButton } from "@/components/ui/dropdown-button";

const routes = [
    { path: "/swap", label: "Swap" },
    { path: "/memeswap", label: "MemeSwap" },
    { path: "/limit", label: "Limit order" },
    { path: "/sniper", label: "Sniper" },
];

const LinksList: FC = () => {
    const location = useLocation();
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef<HTMLDivElement>(null);
    const currentRoute = routes.find((route) => route.path === location.pathname);
    const currentLabel = currentRoute ? currentRoute.label : "Swap";

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
                setIsOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (
        <div className="relative inline-block text-left" ref={dropdownRef}>
            <DropdownButton isOpen={isOpen} setIsOpen={setIsOpen} label={currentLabel} />

            {isOpen && (
                <div className="absolute left-0 mt-2 w-40 origin-top-left  bg-card-solid/80 rounded-3xl backdrop-blur-lg border border-muted-foreground shadow-lg z-20">
                    <div className="p-3">
                        {routes.map((route) => (
                            <NavLink
                                key={route.path}
                                to={route.path}
                                onClick={() => setIsOpen(false)}
                                className={({ isActive }: { isActive: boolean }) =>
                                    `block w-full text-sm text-popover-foreground  hover:text-accent-foreground rounded-xl p-2 border border-transparent transition-all duration-300 ease-in-out  ${isActive ? "font-bold bg-primary/40   border-primary/50 !hover:bg-primary/50" : "hover:bg-muted hover:border hover:border-muted-foreground   opacity-100 hover:opacity-100"}`
                                }
                            >
                                <div className="flex items-center justify-start ">{route.label}</div>
                            </NavLink>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};

export default LinksList;
